import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./globals.css";
import { initializeTheme } from "@/services/shared/utils/theme";

// Initialize theme on app start
initializeTheme();

// Suppress AbortErrors from unhandled promise rejections
// These are expected when React Query cancels requests on component unmount
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    const error = event.reason;
    // Suppress AbortErrors - they're expected cancellations from React Query
    if (
      error instanceof DOMException ||
      error?.name === "AbortError" ||
      error?.message?.includes("aborted") ||
      error?.message?.includes("AbortError") ||
      error?.message?.includes("signal is aborted")
    ) {
      event.preventDefault();
      return;
    }
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
